import { useEffect, useState } from "react";
import { Search } from "lucide-react";

export const StickySearchButton = ({ onClick, label = "Search & filter" }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`lg:hidden fixed bottom-6 left-1/2 z-40 -translate-x-1/2 flex items-center gap-2 rounded-full bg-foreground px-5 py-3.5 text-[13px] font-bold text-background shadow-[0_10px_30px_rgba(0,0,0,0.28)] transition-all duration-300 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
      data-testid="sticky-search-btn"
    >
      <Search className="h-4 w-4" /> {label}
    </button>
  );
};

export default StickySearchButton;
